import { __decorate } from "tslib";
import { Component, Prop, Vue } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import SearchTable from '@/components/SearchTable.vue';
import _ from 'lodash';
import VueMarkdown from 'vue-markdown';
import BackButton from '@/components/BackButton.vue';
const classImprovementModule = namespace('classImprovements');
let CharactersClassImprovements = class CharactersClassImprovements extends Vue {
    constructor() {
        super(...arguments);
        this.initialSearch = '';
        this.tableType = 'Class Improvements';
    }
    created() {
        this.fetchClassImprovements();
        this.initialSearch = this.$route.query.search;
    }
    get items() {
        const page = this.isInHandbook ? 'phb' : 'characters';
        return _(this.classImprovements)
            .filter(({ contentType }) => !this.isInHandbook || contentType === 'Core')
            .map(classImprovement => ({
            ...classImprovement,
            id: classImprovement.name,
            isExpandable: classImprovement.description
        })).value();
    }
    get headers() {
        return [
            {
                text: 'Name',
                value: 'name'
            },
            {
                text: 'Prerequisite',
                value: 'prerequisite'
            },
            {
                text: 'Source',
                value: 'contentSource',
                render: _.startCase,
                filterChoices: ['PHB', 'EC', 'WH'],
                filterFunction: ({ contentSource }, filterValue) => _.startCase(contentSource) === filterValue
            }
        ];
    }
};
__decorate([
    classImprovementModule.State
], CharactersClassImprovements.prototype, "classImprovements", void 0);
__decorate([
    classImprovementModule.Action
], CharactersClassImprovements.prototype, "fetchClassImprovements", void 0);
__decorate([
    Prop({ type: Boolean, default: false })
], CharactersClassImprovements.prototype, "isInHandbook", void 0);
CharactersClassImprovements = __decorate([
    Component({
        components: {
            SearchTable,
            BackButton,
            VueMarkdown
        }
    })
], CharactersClassImprovements);
export default CharactersClassImprovements;
